export const aboutAdvantages = [
    {
        number: "01",
        text: <><b>Более 10 лет</b> успешной работы – проверенная временем репутация</>
    }, {
        number: "02",
        text: <>Лицензия Министерства Образования РФ <b>№ ЛOЗ5-012 98-77 102904289</b></>
    }, {
        number: "03",
        text: <><b>Современные учебные центры</b> с мультимедийным оборудованием</>
    }, {
        number: "04",
        text: <><b>Гибкий график</b> – обучение в удобное для вас время</>
    }, {
        number: "05",
        text: <><b>Собственный автопарк</b> – новые иномарки (указать модели авто)</>
    }, {
        number: "06",
        text: <><b>Собственный автопарк</b> – новые иномарки (указать модели авто)</>
    },
]